var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},[_vm._l((_vm.todolist),function(todo){return _c('todo-item',{key:todo.id,attrs:{"todo":todo}})}),_vm._v(" "),(_vm.todolist.length===0)?_c('li',{staticClass:"list-group-item text-center",domProps:{"innerHTML":_vm._s(_vm.$t('todolist.notodo'))}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b6316f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TodoList.vue
// module id = 24
// module chunks = 2